
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/franchise/potential-markets",
      function () {
        return require("private-next-pages/franchise/potential-markets.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/franchise/potential-markets"])
      });
    }
  